import { useState } from "react"
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  message: string
  width?: number
}

export default function UINewsBar({message, width}: Props){
  const [newsOpen, setNewsOpen] = useState(true)

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setNewsOpen(false);
  };

  if(message.length === 0){
    return <></>
  }

  return(
    <>
        <Snackbar
          sx={{ maxWidth: width? width : 500 }}
          open={newsOpen}
          onClose={handleClose}
          message={'FEATHER NEWS: '+ message}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          action={
            <IconButton
                aria-label="close"
                color="inherit"
                sx={{ p: 0.5 }}
                onClick={handleClose}
              >
                <CloseIcon />
            </IconButton>}
        />
      </>
  )
}